import React from 'react'
import DistributorList from './DistributorList'
import DistributorShow from './DistributorShow'
import LocalConvenienceStore from '@mui/icons-material/LocalConvenienceStore';

const DistributorConfig = {
    list: DistributorList,
    icon: <LocalConvenienceStore />,
    show: DistributorShow,
    options: {
        label: 'Distributor',
        items: true
    }
};

export default DistributorConfig